import i from 'i18next'

import { getCampaignUrl } from '../../helpers'
import HeaderAd from '../elements/HeaderAd'
import { ProductDisplay } from '../elements/ProductDisplay'
import { SponsoredBrandsAssets } from '../SponsoredBrandsAssets'

export const SponsoredBrandsAds = ({
  ads
}: {
  ads: SponsoredAdsResponse[]
}) => (
  <section className="d-flex flex-column gap-4">
    {ads.map(ad => (
      <article key={ad.ad_id}>
        <HeaderAd
          campaignURL={getCampaignUrl(ad.click_url)}
          campaignName={ad.campaign_name}
        />

        {ad.headline && (
          <p className="m-0 fs-6">
            <strong>Headline:</strong> {ad.headline}
          </p>
        )}
        {ad.brand_name && (
          <p className="m-0 fs-6">
            <strong>Brand name:</strong> {ad.brand_name}
          </p>
        )}
        {ad.description && (
          <p className="m-0 fs-6">
            <strong>Description:</strong> {ad.description}
          </p>
        )}

        {ad.brand_url && (
          <div className="mb-2 fs-6">
            <strong>Logo:</strong>
            <br />
            <img
              src={ad.brand_url}
              style={{ maxWidth: '150px', marginTop: '0.5rem' }}
            />
          </div>
        )}

        {ad.assets && ad.assets.length > 0 && (
          <div className="mt-3 fs-6">
            <strong>Assets:</strong>
            <SponsoredBrandsAssets assets={ad.assets} />
          </div>
        )}

        {ad?.products?.length > 0 && (
          <div className="mt-3 fs-6 d-flex flex-column gap-2">
            <strong>{i.t('rm:Products')}:</strong>
            {ad.products.map((product, index) => (
              <ProductDisplay
                key={index}
                product_name={product.product_name}
                product_sku={product.product_sku}
                image_url={product.image_url}
                seller_id={product.seller_id}
              />
            ))}
          </div>
        )}
      </article>
    ))}
  </section>
)
